import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-accordion-comment-calendar',
  templateUrl: './accordion-comment-calendar.component.html',
  styleUrls: ['./accordion-comment-calendar.component.scss']
})
export class AccordionCommentCalendarComponent implements OnInit {
  @Input() leadId: string;
  constructor() { }

  ngOnInit() {
  }

}
